// src/components/Navbar.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "./logo.jpg";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 z-50 w-full h-16 bg-white shadow-md">
      {" "}
      {/* Set height here */}
      <div className="container flex items-center justify-between h-full px-4 py-2 mx-auto">
        {" "}
        {/* Adjusted height */}
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <Link to="/" className="flex items-center px-2 py-2">
            <img src={logo} alt="Shinpex Academy Logo" className="w-8 h-8" />
            <span className="ml-2 text-xl font-semibold text-gray-800">
              Shinpex Academy
            </span>
          </Link>
        </div>
        {/* Desktop Navigation */}
        <div className="items-center hidden space-x-6 md:flex">
          <Link
            to="/"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            About
          </Link>
          {/* <Link
            to="/services"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Services
          </Link> */}
          {/* <Link
            to="/admissions"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            GCE
          </Link> */}
          <Link
            to="/gallery"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Gallery
          </Link>
          <Link
            to="/contact"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Contact
          </Link>
          <Link
            to="/login"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Portal
          </Link>
          <Link
            to="/results"
            className="px-3 py-2 font-semibold text-gray-700 transition duration-300 hover:text-green-600"
          >
            Check Result
          </Link>
        </div>
        {/* Mobile Menu Button */}
        <div className="flex items-center md:hidden">
          <button className="p-2 outline-none" onClick={toggleMenu}>
            {isMenuOpen ? (
              <FaTimes className="text-2xl text-gray-700" />
            ) : (
              <FaBars className="text-2xl text-gray-700" />
            )}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <div
        className={`transform ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } fixed top-0 right-0 w-3/4 h-full bg-white shadow-lg z-40 transition-transform duration-300 ease-in-out`}
      >
        {/* Cancel Button */}
        <div className="flex justify-end p-4">
          <button
            className="text-2xl text-gray-700 outline-none"
            onClick={toggleMenu}
          >
            <FaTimes />
          </button>
        </div>

        <ul className="flex flex-col items-center py-4">
          <li>
            <Link
              to="/"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Services
            </Link>
          </li>
          <li>
            {/* <Link
              to="/admissions"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              GCE
            </Link> */}
          </li>
          <li>
            <Link
              to="/gallery"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Gallery
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Contact
            </Link>
          </li>
          <li>
            <Link
              to="/login"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Portal
            </Link>
            <Link
              to="/results"
              className="block py-4 text-lg font-semibold text-gray-700 transition duration-300 hover:bg-green-500 hover:text-white"
              onClick={toggleMenu}
            >
              Check Result
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
